<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Agence :</label>
                <v-select
                class="custom-select-height"
                  v-model="Agency"
                  :options="AgencyList"
                  label="name"
                  update:modelValue="handleAgencySelection"
                >
                  <template #option="{ name, nb_colis }">
                  <span>{{ name }} - {{ nb_colis }} Colis</span>
                </template>

                </v-select>

              </div>
            </div>
            <div class="col-md-4">
              <label>Livreur :</label>
              <v-select
              class="custom-select-height"
                v-model="Livreur"
                :options="Livreurs"
                label="name"
              >
                <template #option="{ name, nb_colis }">
                  <span>{{ name }} - {{ nb_colis }} Colis</span>
                </template>

              </v-select>
            </div>
            <div class="col-md-4">
              <button
                style="margin-top: 1.2rem;"
                v-if="auth.can('ADD_BP_L')"
                class="btn btn-primary"
                @click="AddPaymentNote"
              >
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import router from "@/router";
export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    // Declare reactive variables
    const AgencyList = ref<Array<any>>([]);
    const Agency = ref<any>({});
    const Livreurs = ref<Array<any>>([]);
    const Livreur = ref<any>({});
    const isLoader = ref(false);

    interface AgencyType {
      id: number;
      name: string;
      id_zone?: number;
      zone_name?: string;
    }

    const handleAgencySelection = (agency: AgencyType) => {
      if (agency?.id) {
        getAgencyLivs(agency.id);
      }
    };

    const AddPaymentNote = async () => {
      if (!Agency.value?.id || !Livreur.value?.id) {
        showToast('Merci de remplir tous les champs', "error");
        return;
      }
      const data = new FormData();
      data.append('for_liv', String(Livreur.value.id));
      data.append('for_name', Livreur.value.name);
      data.append('agency', String(Agency.value.id));
      data.append('agency_name', Agency.value.name);
      data.append('zone_id', Agency.value.id_zone ? String(Agency.value.id_zone) : '');
      data.append('zone_name', Agency.value.zone_name ? Agency.value.zone_name : '');
      data.append('city', Livreur.value.city_id ? String(Livreur.value.city_id) : '0');
      data.append('user_id', user?.id ? String(user.id) : '');

      isLoader.value = true;
      try {
        const res = await api.post(`/api/auth/new_liv_payment`, data);
        isLoader.value = false;
        if (res.data.message === 'success') {
          const routeData = router.resolve({ name: 'edit-payment-note', params: { id: res.data.note_ref.id, refNote: res.data.PayNote.note_ref } });
          window.open(routeData.href, '_blank');
        }
      } catch (error) {
        isLoader.value = false;
        showToast('Something went wrong! Please try again', "error");
      }
    };

    const getAgencyLivs = async (id: number) => {
      Livreur.value = {};
      try {
        const res = await api.get(`/api/auth/payment_livs_list/${id}`);
        Livreurs.value = res.data;
      } catch (error) {
        showToast('Impossible de charger les livreurs', "error");
      }
    };

    onMounted(async () => {
      // Load agencies list on mount
      try {
        const res = await api.get('/api/auth/payment_liv_agencies');
        AgencyList.value = res.data;
      } catch (error) {
        showToast('Impossible de charger les agences', "error");
      }
    });

    return {
      user,
      AgencyList,
      Livreurs,
      Livreur,
      isLoader,
      Agency,
      handleAgencySelection,
      auth,
      AddPaymentNote,
    };
  },
});
</script>
